module.exports = __webpack_public_path__ + "img/react.e170ebeb.svg";